export const STATES = ["Florida", "Alabama", "Mississippi", "Louisiana", "Texas"];

export const ARTIST_TYPES = ["Solo artist", "Band", "DJ", "Karaoke", "Comedy", "Other"];

export const PERFORMANCE_TYPES = [
  "Live band", "Solo performance", "Acoustic", "DJ", "Karaoke", "Comedy",
  "Tribute act", "Original music", "Cover music", "Other",
];

export const GENRES = [
  "Rock", "Pop", "Country", "Jazz/Blues/Soul", "Hip Hop/R&B", "Blues",
  "House / Electronic", "Latin", "Reggae", "Acoustic", "Brass / Funk",
  "Classical", "New Age", "Children's Music", "International", "Cover music", "Other",
];

export const VENUE_TYPES = [
  "Live music", "Bar", "Restaurant", "Beach venue", "Theater", "Festival space", "Event hall",
];

export const PAYMENT_TYPES = ["Fixed", "Hourly", "Tips", "Door split", "Negotiable", "Exposure only"];
